export const subsidiaryListItemIdPrefix = 'subsidiaryListItem-';
export const addressListItemIdPrefix = 'addressListItem-';

export const defaultAddressLine = {
    id: '',
    label: '',
    defaultBilling: true,
    defaultShipping: true,
    primaryAddress: '',
    secondaryAddress: '',
    additionalAddress: '',
    addressRepresentation: '',
    addressee: '',
    attention: '',
    city: '',
    country: null,
    zip: '',
    state: '',
    phone: '',
};
